import './melgroupleondachat/style';
import FormStructure from './melgroupleondachat/form_structure';

export default FormStructure;